import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReact, faDocker, faDev } from "@fortawesome/free-brands-svg-icons";
import Chip from "@mui/material/Chip";
import "../assets/styles/Expertise.scss";

const labelsFirst = [
  "JavaScript",
  "TypeScript",
  "VueJs/ReactJS/AngularJs",
  "NuxtJs/NextJs (Next-Auth)",
  "NodeJs/HonoJs",
  "HTML5",
  "CSS3/Tailwind/SCSS",
  "C/C++/Python/Java",
  "SQL/PostgreSQL/NeonDb/MongoDb",
  "Ionic",
  "PHP/Laravel",
  "ExpressJs",
  "React Native",
  "Vuex/Redux/Recoil",
  "Zod",
  "ETL (data migration/analysis)",
  "WebRTC",
  "NewRelic-monitoring/Sentry",
  "Prometheus-Grafana",
  "GRPC",
  "TRPC",
  "Socket.io",
  "Unit testing",
  "Integration testing",
  "End to end testing",
];

const labelsSecond = [
  "Git",
  "GitHub Actions",
  "Docker",
  "AWS",
  "Snowflake",
  "Kubernetes",
  "Netlify",
  "Vercel",
  "DigitalOcean",
  "Container Orchestration",
  "Cloudfare",
];

const labelsThird = [
  "AppFlow (OTA updates for apps)",
  "MonoRepos/TurboRepos",
  "Npm packages",
  "Redis",
  "Apache-kafka",
  "Postman",
  "Hoppscotch",
  "Prisma ORM",
  "Cloudfare workers",
  "Pub-subs",
  "Queues",
  "OpenAPI Spec",
  "CSR/SSR/SSG",
];

function Expertise() {
  return (
    <div className="container" id="expertise">
      <div className="skills-container">
        <h1>Expertise</h1>
        <div className="skills-grid">
          <div className="skill">
            <FontAwesomeIcon icon={faReact} size="3x" />
            <h3>Full Stack Web Development</h3>
            <p>
              I have built a diverse array of web applications from scratch
              using modern technologies such as VueJs and React Native. I have a
              strong proficiency in the SDLC process and frontend + backend
              development.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsFirst.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faDocker} size="3x" />
            <h3>DevOps & Automation</h3>
            <p>
              Once the application is built, I help set up DevOps testing, CI/CD
              pipelines, and deployment automation to support the successful
              Go-Live.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsSecond.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faDev} size="3x" />
            <h3>DevTools</h3>
            <p>
              A list of tools/technologies I have leveraged to make the
              development easy and speed up the development without compormising
              the quality and improving user experience for the end user.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsThird.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Expertise;
